import qrcode from 'qrcode-generator';
import { device } from './device.js';
import { t } from './i18n.js';
import { escapeHtml } from './utils.js';

/* Abrir una dirección fuera de Filoteca («Ver en Netflix», el tráiler en YouTube, comprar la licencia…):
   - Windows: el navegador del sistema (puente de Electron).
   - Android / Android TV / Fire TV: se le pide al sistema (navegador o la app que reclame esa dirección, p. ej. Netflix).
     Dentro de la propia ventana no: la app permite navegar a cualquier sitio y se quedaría Netflix cargado en Filoteca.
   - Si en la tele no hay nadie que la abra (muchos Fire TV no tienen navegador), se enseña un código QR para abrirla con el móvil.
   - Web: una pestaña nueva. */

export function qrSvg(text) {
    try {
        const qr = qrcode(0, 'M');
        qr.addData(text);
        qr.make();
        return qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
    } catch (e) {
        return '';
    }
}

/** Código QR con la dirección, para abrirla en el móvil (teles sin navegador). */
export function showLinkQr(url, { title } = {}) {
    const app = window.app;
    if (!app || !app.dialog) return;
    const short = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
    const dialog = app.dialog.create({
        title: title || t('external.title'),
        text: `<div class="phone-body"><p class="pw-note">${escapeHtml(t('external.text'))}</p>
            <div class="phone-grid"><div class="pair-qr phone-qr" aria-hidden="true">${qrSvg(url)}</div>
            <div class="phone-side"><div class="phone-url" style="word-break:break-all;font-size:14px">${escapeHtml(short.length > 90 ? short.slice(0, 90) + '…' : short)}</div></div></div></div>`,
        buttons: [{ text: t('common.close'), bold: true }]
    });
    dialog.open();
    return dialog;
}

/**
 * Abre `url` fuera de la app. Devuelve una promesa con true si alguien la abrió (o se enseñó el QR).
 * `title`: título del diálogo del QR cuando la tele no puede abrirla.
 */
export async function openExternal(url, { title } = {}) {
    url = String(url || '');
    if (!/^https?:\/\//.test(url)) return false;
    if (device.isElectron && window.electronBridge && window.electronBridge.openExternal) {
        try { await window.electronBridge.openExternal(url); return true; } catch (e) { return false; }
    }
    if (device.isCordova) {
        const tv = window.cordova && window.cordova.plugins && window.cordova.plugins.filotecaTv;
        if (tv && typeof tv.openUrl === 'function') {
            let ok = false;
            try { ok = await tv.openUrl(url); } catch (e) { ok = false; }
            if (ok) return true;
            // Nadie reclama esa dirección en este aparato: en la tele, el QR para el móvil; en el móvil no debería pasar.
            showLinkQr(url, { title });
            return true;
        }
        if (device.isTV) { showLinkQr(url, { title }); return true; }
        window.open(url, '_system');
        return true;
    }
    if (device.isTV) { showLinkQr(url, { title }); return true; }
    const w = window.open(url, '_blank', 'noopener');
    return !!w;
}
